import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ListChecks, AlertCircle, CalendarClock, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLES = ['system_admin', 'executive', 'executive_leadership', 'operations_manager', 'case_manager_supervisor', 'case_manager'];

// Dashboard card: the logged-in user's referral contacts due today or overdue
export const OutreachQueueDashboardCard = ({ role }) => {
  const [q, setQ] = useState(null);
  useEffect(() => {
    if (!ROLES.includes(role)) return;
    axios.get(`${API}/referral-tracker/my-queue`).then((r) => setQ(r.data)).catch(() => setQ(null));
  }, [role]);
  if (!q || !q.has_contacts) return null;
  const overdue = q.overdue_count;
  return (
    <Card className={`card-shadow border-l-4 ${overdue ? 'border-l-red-500' : 'border-l-primary'}`} data-testid="dashboard-outreach-queue">
      <CardContent className="p-5 flex flex-wrap items-center gap-6">
        <div className="flex items-center gap-3">
          <ListChecks className="w-8 h-8 text-primary" />
          <div>
            <p className="font-semibold">My Outreach Queue</p>
            <p className="text-sm text-muted-foreground">Referral contacts assigned to you</p>
          </div>
        </div>
        <div className="flex items-center gap-2" data-testid="dashboard-outreach-overdue">
          <AlertCircle className={`w-5 h-5 ${overdue ? 'text-red-600' : 'text-muted-foreground'}`} />
          <span className={`text-2xl font-bold tabular-nums ${overdue ? 'text-red-600' : ''}`}>{overdue}</span>
          <span className="text-sm text-muted-foreground">overdue</span>
        </div>
        <div className="flex items-center gap-2" data-testid="dashboard-outreach-due-today">
          <CalendarClock className="w-5 h-5 text-amber-600" />
          <span className="text-2xl font-bold tabular-nums">{q.due_today_count}</span>
          <span className="text-sm text-muted-foreground">due today</span>
        </div>
        <Button asChild variant={overdue ? 'default' : 'outline'} className="ml-auto" data-testid="dashboard-outreach-open-btn">
          <Link to="/referral-tracker">Open My Outreach Queue<ArrowRight className="w-4 h-4 ml-2" /></Link>
        </Button>
      </CardContent>
    </Card>
  );
};
